import { Quote } from "lucide-react";
import { MaskText, SectionLabel, Reveal } from "./primitives";

const ITEMS = [
  {
    quote:
      "We treat every brand like a patient — diagnose before we prescribe. No templates, no guesswork, just the right idea backed by strategy.",
    name: "Founder & Creative Director",
    role: "Doctor Media",
  },
  {
    quote:
      "One senior team owns your project end to end. Strategy, design and production sit in the same room, so nothing gets lost in hand-offs.",
    name: "Managing Director",
    role: "Doctor Media",
  },
  {
    quote:
      "We only call it done when it moves a number. Every campaign we ship is built to be measured, optimised and repeated.",
    name: "Head of Strategy",
    role: "Doctor Media",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-dm-dark grain py-24 md:py-32"
    >
      <div className="relative z-10 mx-auto max-w-[1500px] px-6 md:px-12">
        <div className="max-w-3xl">
          <SectionLabel tone="maroon" className="text-white/80">From the studio</SectionLabel>
          <MaskText
            lines={["How the people", "who run it, think."]}
            className="mt-5 font-display font-extrabold text-white tracking-tighter leading-[0.95] text-4xl sm:text-5xl md:text-6xl"
          />
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {ITEMS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full rounded-2xl p-8 backdrop-blur-md border flex flex-col"
                style={{ background: "rgba(255,255,255,0.04)", borderColor: "rgba(255,255,255,0.12)" }}
              >
                <Quote size={30} style={{ color: "var(--dm-maroonbright)" }} className="mb-5" />
                <blockquote className="text-white/85 leading-relaxed text-lg flex-1">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-7 pt-5 border-t border-white/10">
                  <div className="font-display font-bold text-white text-lg">{t.name}</div>
                  <div className="text-white/50 text-sm font-oswald uppercase tracking-wide mt-1">{t.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
